import { REGIONS } from 'app/lib/constants'
import { colors } from 'app/theme'

import type { Config } from '.'

const hostOverrides: Record<string, Partial<Config>> = {
  'admin-test.dialogue.co': {
    auth0: {
      audience: 'https://api.dialoguecorp.com',
      clientId: 'UNGQotSD08gyLaPYXGmogQRNBtkBxryy',
      domain: 'auth.dialogue.co',
      connections: {
        okta: 'test-okta-saml',
      },
    },
  },
  'admin-demo.dialogue.co': {
    auth0: {
      audience: 'https://api.dialoguecorp.com',
      clientId: 'hzCDfgo1KHRrbpESF7gs1GuDpLu1k3vi',
      domain: 'auth.dialogue.co',
      connections: {
        okta: 'demo-okta-saml',
      },
    },
  },
}

export const productionConfig = Object.freeze<Config>({
  auth0: {
    audience: 'https://api.dialoguecorp.com',
    clientId: 'ArDCt32ocvqgkvSa4eecdaNG7XNPN3ie',
    domain: 'auth.dialogue.co',
    connections: {
      adp: 'adp-admin',
    },
  },
  launchDarkly: {
    clientId: '6295189ae11a2e14fd1b74cf',
  },
  scribe: {
    baseUrl: 'https://scribe.dialoguecorp.com',
  },
  multipass: {
    baseUrl: 'https://multipass.dialoguecorp.com',
  },
  coredata: {
    baseUrl: 'https://coredata.dialoguecorp.com',
  },
  activeMinutes: {
    baseUrl: 'https://active-minutes.dialoguecorp.com',
  },
  stripePublicKey: 'pk_live_mMeepfha0s3atBB59RWG9mIj',
  theme: {
    applicationBar: {
      backgroundColor: colors.dialogueCharcoal,
    },
  },
  assets_url: 'https://assets.dialoguecorp.com/maestro/master',
  snowplow: {
    appId: 'presto',
    namespace: 'prod-ca',
    endpoint: 'https://lawnmower.dialoguecorp.com',
  },
  datadog: {
    applicationId: 'f1d945c0-d56a-4cbc-bcee-b40a9ee21eb5',
    clientToken: 'pub1762d69b189329e7a6090917b1e186a7',
    site: 'datadoghq.com',
    env: 'prod-ca',
  },
  zendesk: {
    widgetKey: '56208ba2-b5d6-408e-b01f-3b3e141e051c',
  },
  region: REGIONS.CANADA,
  ...hostOverrides[window.location.hostname],
})
